import React from "react";
import { FormCodeValidateComponent, FormSignupComponent } from "../../../site/impl/components";
import { LoginContainerFactory } from "../screens";

export class SignupContainerFactoryImpl implements LoginContainerFactory {
    constructor(
        private currentStep: number,
        private setStep: React.Dispatch<React.SetStateAction<number>>,
        private signupFormData: FormData | undefined,
        private setSignupFormData: React.Dispatch<React.SetStateAction<FormData | undefined>>
    ) { }
    create(): React.ReactNode {
        if (this.currentStep === 1) {
            return <FormSignupComponent step={this.currentStep} setStep={this.setStep} setData={this.setSignupFormData} formData={this.signupFormData} />
        }
        return <FormCodeValidateComponent step={this.currentStep} setStep={this.setStep} setData={this.setSignupFormData} formData={this.signupFormData} showVersion />
    }
}